<template>
    <b-container class="card-holder" fluid>
        <b-container fluid style="margin-left: 0px; width: 100%">

            <b-row>
                <b-col cols="2" class="no-gutters">
                    <NavMenu width="100%;"/>
                </b-col>
                <b-col cols="7" style="padding-left: 5px">
                    <div>
                        <b-container>
                            <div style="background-color: rgba(111, 183, 80, 0.20);"
                                 class="short-articles columns-content">
                                <p> Thank you for your interest in becoming Napa Green Winery certified. If you are
                                    interested in hearing from peers about the benefits of Napa Green certification
                                    please check out this video.
                                    The Napa Green Winery certification represents a recognition that environmental
                                    stewardship and sustainability doesn’t end in the vineyard. Winemaking and
                                    hospitality present numerous opportunities to further integrate conscientious
                                    business practices, maximize resource efficiency for time and cost savings, and help
                                    educate and engage staff and customers on the value of green business practices.
                                    Sustainable winegrowing requires attention to detail that can not only increase the
                                    quality of the wine in the glass but also elevate the luxury experience.
                                    Please fill out the information below. Once submitted you will be sent a link to
                                    setup your username and password in order to access the Winery Application Checklist
                                    and associated resources. We want to emphasize that the Napa Green Winery standards
                                    include many industry best practices so no one is starting from the ground floor.
                                    Most wineries are already at least 50% of the way toward meeting the standards. To
                                    achieve certification there needs to be a commitment to continuing improvement and a
                                    willingness to invest the time to move further along the path of sustainability. It
                                    is critical that top-level leadership clearly communicate that sustainability and
                                    environmental stewardship are priorities and emphasize the importance of integrating
                                    sustainability into day-to-day operations.
                                    Once certified you will receive all of the benefits of Napa Green Winery membership,
                                    including logo use guidelines, free Napa Green Certified signage, recognition on
                                    NapaGreen.org, access to BMP workshops, happy hours and other celebration and
                                    recognition events.
                                    We are always available to help answer any questions. Please reach out anytime.
                                </p>
                            </div>
                        </b-container>
                        <b-container>
                            <div class="short-articles columns-content" style="background-color: #f8f8f8">
                                <p>How do I complete this level?</p>

                                Complete all the measures in each of the categories you see in
                                the left column. If you’re not sure of the answer or
                                the measure isn’t applicable to your business, just select N/A.
                                When you've finished answering all the measure questions, select
                                'Submit My Checklist' from the Review page. Your Coordinator will
                                setup a phone consultation and site visit.
                            </div>
                        </b-container>
                        <b-container>
                            <div class="short-articles columns-content" style="background-color: #f8f8f8">
                                <p>What do I get when and why should I complete the next level?</p>

                                When a business completes the Certified Level, they become eligible
                                for a package of marketing tools such as an online directory listing,
                                Google Adwords traffic, social media recognition, logos and other
                                graphics, and much more. If you go on to complete the next level,
                                you'll be featured on the California Green Business Network's website
                                and in the quarterly newsletter, in addition to community recognition.
                            </div>
                        </b-container>
                        <b-container>
                            <div class="short-articles columns-content" style="background-color: #f8f8f8">
                                <p>How do I navigate between tiers?</p>
                                You can preview or even start working the next tier any time by
                                selecting the ‘NEXT TIER’ button in the upper right corner of each
                                checklist page.
                            </div>
                        </b-container>
                    </div>
                </b-col>
                <b-col cols="3">
                    <b-container class="background-grey columns-content short-articles clear" style="display: block; ">

                        <p class="short-benefits-title" style="margin-left: 20px">TIER BENEFITS</p>
                        <ul class="fa-ul">
                            <li class="tier-benefits">
                                <!-- Create an icon wrapped by the fa-stack class -->
                                <span class="fa-stack">
                                <!-- The icon that will wrap the number -->
                                <span class="fas fa-circle fa-stack-2x" style="color: #6fb750"></span>
                                    <!-- a strong element with the custom content, in this case a number -->
                                <strong class="fa-stack-1x" style="color: white">
                                    1
                                </strong>
                                </span>
                                CERTIFIED BENEFITS
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>All Participant Benefits
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Online Directory Listing
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Access to Media Toolkit
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Google Adwords Traffic
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Program Window Cling Decal
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Framed Certificate
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Local Gov Recognition
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Social Media Recognition
                            </li>

                            <li class="tier-benefits"><span class="fa-li">
                                <i class="fas fa-check-circle" style="color: #6fb750"></i>
                                    </span>Regional Newsletter Feature
                            </li>
                        </ul>
                    </b-container>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
import NavMenu from "./NavMenu";

export default {
  components: {NavMenu},
  methods: {
    goToMyTeam: function () {
      console.log("Logging in.")
      this.$router.push({path: '/groups'});
    },
    goToAccountInfo: function () {
      console.log("Logging in.")
      this.$router.push({path: '/update-account-info'});
    },
            goToUpdatePassword: function () {
                console.log("Logging in.")
                this.$router.push({path: '/update-password'});
            }
            ,
            goToMySurvey: function () {
                console.log("Logging in.")
                this.$router.push({path: '/survey?surveyId=1'});
            }
        }
    }
</script>


<style scoped>

    .card {
        display: inline-block;
        height: 120px;
        width: 30%;
        border: thin #1b1e21;
        margin: 5px;
        text-align: center;
    }

    .card-holder {
        width: 100%;
        margin-top: 10px;
    }

    .tier-benefits {
        margin: 3px;
    }

    .background-grey {
        background-color: #f8f8f8;
    }

    element.style {
    }

    .background-grey {
        background-color: #f8f8f8;
    }

    .columns-content {
        position: relative;
        border: 1px solid rgb(244, 244, 244);
        -webkit-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        -moz-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        padding: 25px 0 0;
        margin-bottom: 30px;
        /* margin: 0 40px 50px; */
        min-height: 100px;
    }

    .clear:after {
        display: block;
        content: '';
        clear: both;
    }

    .full-width .nav-tabs .nav-item {
        margin-bottom: -1px;
        flex-grow: 1;
        text-align: center;
    }

    .full-width .card-header-tabs {
        margin-right: -21px;
        margin-left: -21px;
    }

    .columns-content {
        position: relative;
        border: 1px solid rgb(244, 244, 244);
        -webkit-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        -moz-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        padding: 25px 0 0;
        margin-bottom: 30px;
        /* margin: 0 40px 50px; */
        min-height: 100px;
    }

    .short-articles, .tier-info {
        margin-bottom: 15px;
        word-wrap: break-word;
        font-size: 16px;
        font-family: "Lato", sans-serif;
        font-weight: 400;
        padding-left: 25px;
        padding-right: 25px;
        padding-bottom: 25px;
        float: left;
        width: 100%;
        border-radius: 20px;
    }

</style>
